import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TransformObjectFormService } from './transform-object-form.service';
export class TNKTransformObjectFormModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  declarations: [],
  exports: [],
  providers: [TransformObjectFormService],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TNKTransformObjectFormModule_tsickle_Closure_declarations() {
/** @type {?} */
TNKTransformObjectFormModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TNKTransformObjectFormModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
